import { render } from "./InvitedCoCrb.vue?vue&type=template&id=bde0319a&scoped=true"
import script from "./InvitedCoCrb.vue?vue&type=script&lang=js"
export * from "./InvitedCoCrb.vue?vue&type=script&lang=js"

import "./InvitedCoCrb.vue?vue&type=style&index=0&id=bde0319a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde0319a"]])

export default __exports__